
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/about-us",
      function () {
        return require("private-next-pages/[lang]/about-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/about-us"])
      });
    }
  